var variant="";(function(){document.addEventListener("theme:variant:change",function(event){variant=event.detail.variant,container=event.target;variant&&(console.log("Container \u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014 \u2193"),console.log(container),console.log("Variant \u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014 \u2193"),console.log(variant),UpdateComparePrice(variant))}),document.addEventListener("theme:cart:change",function(event){var cart=event.detail.cart;cart&&(console.log("Cart \u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014 \u2193"),console.log(cart))}),document.addEventListener("theme:cart:init",function(e){console.log("theme:cart:init"),console.log(e)}),document.addEventListener("theme:scroll",function(e){console.log(e)}),document.addEventListener("theme:scroll:up",function(e){console.log(e)}),document.addEventListener("theme:scroll:down",function(e){console.log(e)}),document.addEventListener("theme:resize",function(e){console.log(e)})})();document.addEventListener('DOMContentLoaded',function(){const variantSelectors=document.querySelectorAll('[data-variant-selector]');variantSelectors.forEach(function(selector){selector.addEventListener('change',function(event){const selectedVariant=event.target.value;console.log(selectedVariant,"selected variant");updatePrices(selectedVariant)})})});function updatePrices(variant){const priceElement=document.getElementById('current-price');const compareAtPriceElement=document.getElementById('compare-at-price');priceElement.innerHTML=Shopify.formatMoney(variant.price,"{{ shop.money_format }}");if(variant.compare_at_price>variant.price){compareAtPriceElement.innerHTML=Shopify.formatMoney(variant.compare_at_price,"{{ shop.money_format }}");compareAtPriceElement.style.display='inline'}else{compareAtPriceElement.style.display='none'}}
function UpdateComparePrice(variant){const compareAtPriceElement=document.getElementById('compare-at-price');compareAtPriceElement.innerText=formatNumberWithCommas(variant.compare_at_price);console.log(formatNumberWithCommas(variant.compare_at_price)," variant id")}
function formatNumberWithCommas(number){const numberString=number.toString();const lastTwoDigits=numberString.slice(-2);const remainingIntegerPart=numberString.slice(0,-2);const formattedIntegerPart=remainingIntegerPart.replace(/\B(?=(\d{3})+(?!\d))/g,',');const formattedNumber=`Rs. ${formattedIntegerPart}.${lastTwoDigits}`;return formattedNumber}
function initializeCounterButtons(){document.removeEventListener("click",handleCounterClick);document.addEventListener("click",handleCounterClick)}
function handleCounterClick(event){if(event.target.classList.contains("increment")||event.target.classList.contains("decrement")){let counterWrapper=event.target.closest(".counter-wrapper");if(!counterWrapper)return;let counterInput=counterWrapper.querySelector(".counter");if(!counterInput)return;let value=parseInt(counterInput.value);if(event.target.classList.contains("increment")){counterInput.value=value+1}else if(event.target.classList.contains("decrement")&&value>1){counterInput.value=value-1}}}
document.addEventListener("DOMContentLoaded",initializeCounterButtons);document.addEventListener("shopify:section:load",initializeCounterButtons);document.addEventListener("shopify:section:reorder",initializeCounterButtons);document.addEventListener("shopify:section:unload",initializeCounterButtons)


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.pdp-video-play');
  if (!btn) return;

  const wrap = btn.closest('.pdp-video-wrap');
  const video = wrap.querySelector('.js-pdp-video');
  if (!video) return;

  // Enable native controls AFTER click
  video.setAttribute('controls', 'controls');

  // Load + play (valid user gesture)
  video.preload = 'auto';
  video.load();
  video.play().catch(() => {
    video.muted = true;
    video.play();
  });

  // Remove overlay
  btn.remove();
});

 // Add to cart product grid button
 
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('#btn-custom-grid');
  if (!btn) return;

  e.preventDefault();

  const originalText = btn.innerHTML;

  try {
    btn.disabled = true;
    btn.innerHTML = 'Adding...';

    const form = btn.closest('form');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    });

    await response.json();

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    btn.innerHTML = 'Added';

    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.disabled = false;
    }, 1500);

  } catch (error) {
    console.error(error);

    btn.innerHTML = 'Error';

    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.disabled = false;
    }, 1500);
  }
});
